// Google Maps API Configuration
// This file ensures the API key is always available in the build

// Hardcoded API key for production (will be embedded in build)
// Project: darshan-content-engine (billing enabled). Browser key restricted to
// zammernow.com / *.zammernow.com / localhost:3000 and Maps JS + Places APIs.
const HARDCODED_API_KEY = 'AIzaSyDbX5rt1T3euNeVg_ziTe_mltDZDztlLe0';

export const GOOGLE_MAPS_API_KEY = 
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 
  HARDCODED_API_KEY;

export default GOOGLE_MAPS_API_KEY;

